import { ISimulationModel } from "../simulationModel";
import { ScorpionSerializableModel } from "./scorpionSerializableModel";
import { ScorpionSolitaire } from "./scorpionSolitaire";

export class ScorpionSimulationModel extends ScorpionSerializableModel implements ISimulationModel<ScorpionSolitaire> {
}